/**
 * MISSPOCA 首圖背景影片（2026-07-05）
 * 自動播放、靜音、循環、手機內嵌播放。影片蓋在原首圖上、文字卡之下。
 * 不支援自動播放或減少動態偏好 → 保留原本靜態首圖。
 */
(function () {
  var doc = document;
  if (!doc.body || doc.body.className.indexOf('template-index') === -1) return;
  if (!window.MSP_HERO_VIDEO) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var hero = doc.querySelector('.misspoca-hero');
  var bg = hero && hero.querySelector('.misspoca-hero-bg');
  if (!hero || !bg) return;

  function injectVideo() {
    var v = doc.createElement('video');
    v.className = 'misspoca-hero-video';
    v.muted = true; v.defaultMuted = true; v.loop = true; v.autoplay = true; v.playsInline = true;
    ['muted', 'playsinline', 'autoplay', 'loop'].forEach(function (a) { v.setAttribute(a, ''); });
    v.setAttribute('aria-hidden', 'true');
    v.preload = 'auto';
    if (window.MSP_HERO_POSTER) v.poster = window.MSP_HERO_POSTER;

    var s = doc.createElement('source');
    s.src = window.MSP_HERO_VIDEO; s.type = 'video/mp4';
    v.appendChild(s);

    bg.parentNode.insertBefore(v, bg.nextSibling);

    var p = v.play();
    if (p && p.catch) p.catch(function () { /* 自動播放被擋 → 保留靜態圖 */ });
  }

  // SEO 第二波效能：影片(1.14MB)延到頁面載完+閒置才下載，不跟首屏搶頻寬；背景圖先撐住畫面
  if (doc.readyState === 'complete') {
    if (window.requestIdleCallback) requestIdleCallback(injectVideo, { timeout: 2000 });
    else setTimeout(injectVideo, 200);
  } else {
    window.addEventListener('load', function () {
      if (window.requestIdleCallback) requestIdleCallback(injectVideo, { timeout: 2000 });
      else setTimeout(injectVideo, 200);
    });
  }
})();
